import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "hospital-visit-top" }
const _hoisted_3 = { class: "hospital-visit-top-container" }
const _hoisted_4 = { class: "hospital-visit-top-title" }
const _hoisted_5 = { class: "hospital-visit-top-caution" }
const _hoisted_6 = { class: "hospital-visit-top-heading" }
const _hoisted_7 = { class: "hospital-visit-top-heading-title" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "hospital-visits" }
const _hoisted_10 = {
  key: 0,
  class: "hospital-visits-future-container"
}
const _hoisted_11 = { class: "hospital-visits-future-flow" }
const _hoisted_12 = { class: "hospital-visit-item-header" }
const _hoisted_13 = { class: "hospital-visit-detail-1" }
const _hoisted_14 = { class: "hospital-visit-detail-1-datetime" }
const _hoisted_15 = {
  key: 0,
  class: "hospital-visit-detail-1-datetime-date"
}
const _hoisted_16 = {
  key: 1,
  class: "hospital-visit-detail-1-datetime-date"
}
const _hoisted_17 = {
  key: 2,
  class: "hospital-visit-detail-1-datetime-time"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "pc-only" }
const _hoisted_20 = { class: "hospital-visit-detail-2" }
const _hoisted_21 = { class: "hospital-visit-detail-2-hospital-name" }
const _hoisted_22 = { class: "hospital-visit-detail-2-label" }
const _hoisted_23 = { class: "hospital-visit-detail-3" }
const _hoisted_24 = {
  key: 0,
  class: "hospital-visit-detail-3-department"
}
const _hoisted_25 = { class: "hospital-visit-detail-3-disease" }
const _hoisted_26 = { class: "hospital-visit-item-body" }
const _hoisted_27 = { class: "hospital-visit-appendix" }
const _hoisted_28 = { class: "hospital-visit-appendix-prepare" }
const _hoisted_29 = { class: "hospital-visit-appendix-prepare-text" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "hospital-visit-appendix-update" }
const _hoisted_32 = {
  key: 0,
  class: "hospital-visit-add-button-container"
}
const _hoisted_33 = { class: "hospital-visit-top-container" }
const _hoisted_34 = { class: "hospital-visit-top-heading" }
const _hoisted_35 = { class: "hospital-visit-top-heading-title" }
const _hoisted_36 = { class: "hospital-visits hospital-visits-past" }
const _hoisted_37 = { class: "hospital-visits-filter" }
const _hoisted_38 = { class: "hospital-visits-filter-title" }
const _hoisted_39 = { class: "hospital-visits-filter-title-text" }
const _hoisted_40 = { class: "hospital-visits-filter-content" }
const _hoisted_41 = { class: "hospital-visits-filter-year" }
const _hoisted_42 = ["value", "selected"]
const _hoisted_43 = { class: "hospital-visits-filter-text" }
const _hoisted_44 = { value: "" }
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "hospital-visit-item-header" }
const _hoisted_47 = { class: "hospital-visit-detail-1" }
const _hoisted_48 = { class: "hospital-visit-detail-1-datetime" }
const _hoisted_49 = {
  key: 0,
  class: "hospital-visit-detail-1-datetime-date"
}
const _hoisted_50 = {
  key: 1,
  class: "hospital-visit-detail-1-datetime-time"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "pc-only" }
const _hoisted_53 = { class: "hospital-visit-detail-2" }
const _hoisted_54 = { class: "hospital-visit-detail-2-hospital-name" }
const _hoisted_55 = { class: "hospital-visit-detail-2-label" }
const _hoisted_56 = { class: "hospital-visit-detail-3" }
const _hoisted_57 = {
  key: 0,
  class: "hospital-visit-detail-3-department"
}
const _hoisted_58 = { class: "hospital-visit-detail-3-disease" }
const _hoisted_59 = { class: "hospital-visit-item-body" }
const _hoisted_60 = { class: "hospital-visit-appendix" }
const _hoisted_61 = { class: "hospital-visit-appendix-prepare" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "hospital-visit-appendix-update" }

import dayjs from "dayjs";
import "dayjs/locale/ja";

import { ref, onMounted, reactive, computed } from "vue";
import { useRouter } from "vue-router";
import { _$t } from "@/utils/i18n";

import { HospitalVisit } from "@/models/myRecord/hospitalVisit";
import ErrorDialog from "@/views/base/CommonMessage.vue";
import HospitalVisitEdit from "@/views/pages/MyRecord/HospitalVisit/HospitalVisitEdit.vue";
import Pagination from "@/views/base/Pagination.vue";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import { processend, processing } from "@/utils/view";

type Disease = {
  id: string;
  name: string;
};

// 日付のローカライズ
const componentId = "healthcaredata02-01";
const activeMenu = "my-record";

const MAX_HOSPITAL_VISIT_DISPLAY_COUNT = 2;
const MAX_HOSPITAL_VISIT_COUNT = 10;

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.locale("ja");

// ---- Constants & Variables ------------------------------
const router = useRouter();
const hospitalVisit = new HospitalVisit();

const showAllFutureVisits = ref<boolean>(false);
const hasPastVisits = ref<boolean>(false);
const isInitialized = ref<boolean>(false);
const isFirstPaginationLoad = ref<boolean>(true);
const hospitalVisits = ref();
const pastHospitalVisits = ref();
const pastVisitElement = ref<HTMLDivElement | null>(null);
const paginationRefreshKey = ref<number>(0);

// 選択肢
const userDiseases = ref<Disease[]>();
const years = Array.from({ length: 5 }, (_, i) => dayjs().year() - i);

// 選択値
const selectedYear = ref(years[0]);
const selectedDisease = ref<string>("");

const selectedHospitalVisitId = ref<number | null>(null);
const showHospitalVisitAddEditModal = ref<boolean>(false);

// --- Error handling -----------------------------------------
// セッションエラー判定フラグ
const sessionErr = ref(false);
// エラーダイアログ管理
const errorDialog = reactive({
  show: false,
  okButtonHide: true,
  okName: _$t("survey_msg_ok_btn"),
  safe: true,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialog.message = message;
    errorDialog.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialog.show = false;
    errorDialog.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

const paginationProps = reactive({
  cond: {
    year: years[0],
    disease: "",
  },
  refresh: paginationRefreshKey.value,
  size: 12,
  getTotalCount: (cond: any): Promise<number> => {
    return hospitalVisit.getHospitalVisitCount(cond);
  },
  getPageData: (page: number, size: number, cond: any): Promise<any> => {
    return hospitalVisit.getPaginatedData(page, cond);
  },
});

// ---- Function ----------------------------------------------
const goBack = () => {
  router.back();
};

const goToClinicNote = (hospitalVisitId: number) => {
  router.push({
    name: "ClinicNote",
    params: { hospitalVisitId },
  });
};

const notify = (result: any) => {
  if (result.isSuccess) {
    pastHospitalVisits.value = result.data;
  } else {
    pastHospitalVisits.value = [];
    const status = result.data.error?.response?.status;
    // セッションエラー
    if (status === 408) {
      const decodedMessage = decodeURIComponent(
        result.data.error?.response?.data?.message
      );
      sessionErr.value = true;
      errorDialog.open(decodedMessage);
    }
    return;
  }
};

// これからの件数
const futureVisitsCount = computed(() => hospitalVisits.value?.length);

// 全てのこれからの表示管理
const toggleDisplayAll = () => {
  showAllFutureVisits.value = !showAllFutureVisits.value;
};

// これからの表示された
const futureVisitsPreview = computed(() => {
  return showAllFutureVisits.value
    ? hospitalVisits.value
    : hospitalVisits.value.slice(0, MAX_HOSPITAL_VISIT_DISPLAY_COUNT);
});

// 過去の受診のフィルター条件変更
const filterVisits = () => {
  isFirstPaginationLoad.value = false;
  paginationProps.cond = {
    ...paginationProps.cond,
    year: selectedYear.value,
    disease: selectedDisease.value,
  };
  // Scroll immediately when filter changes
  if (pastVisitElement.value) {
    pastVisitElement.value.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

// 追加編集モーダル開ける
const handleHospitalVisitModalOpen = (id?: number) => {
  showHospitalVisitAddEditModal.value = true;
  selectedHospitalVisitId.value = id || null;
};

// 追加編集モーダル閉じる
const handleHospitalVisitModalClose = () => {
  showHospitalVisitAddEditModal.value = false;
  selectedHospitalVisitId.value = null;
};

const refreshHospitalVisits = async () => {
  await fetchHospitalVisits();
  paginationRefreshKey.value += 1;
  paginationProps.refresh = paginationRefreshKey.value;
};

// 最初のデータ取得
const fetchHospitalVisits = async () => {
  const [_model, response, err] = await hospitalVisit.getPageData();
  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialog.open(decodedMessage);
    return;
  }

  userDiseases.value = response.data?.diseases;
  hospitalVisits.value = response.data?.futureVisits;
  hasPastVisits.value = response.data?.hasPastVisits;
  isInitialized.value = true;
};

// ---- Vue lifeCycle -----------------------------------------
onMounted(() => {
  fetchHospitalVisits();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Header, { "active-menu": activeMenu }),
        _createElementVNode("main", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "hospital-visit-top-back-button",
              onClick: goBack
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: "/server/necs/images/arrow-right_icon.png",
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospitalVisit_card_button_back")), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("hospitalVisit_title")), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("hospitalVisit_caution", { count: MAX_HOSPITAL_VISIT_COUNT })), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("hospitalVisit_heading_title_from_now_on")), 1),
                _createElementVNode("button", {
                  class: "hospital-visit-top-heading-button",
                  onClick: _cache[0] || (_cache[0] = () => handleHospitalVisitModalOpen()),
                  disabled: hospitalVisits.value?.length >= MAX_HOSPITAL_VISIT_COUNT
                }, _toDisplayString(_ctx.$t("hospitalVisit_heading_button_add")), 9, _hoisted_8)
              ])
            ])
          ]),
          (isInitialized.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_9, [
                  (!hospitalVisits.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                          src: "/server/necs/images/hospital_visit_future_flow.png",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("p", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.$t("hospitalVisit_body_label_1")), 1),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t("hospitalVisit_body_label_2")), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(futureVisitsPreview.value, (hospitalVisit) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "hospital-visit-item",
                            key: hospitalVisit.hospitalVisitId
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("p", _hoisted_14, [
                                  (hospitalVisit?.visitDate)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(dayjs)(hospitalVisit.visitDate).format("M月D日(dd)")), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t("hospitalVisit_card_text_date_not_confirmed")), 1)),
                                  (hospitalVisit?.visitTime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(dayjs)(hospitalVisit.visitTime).format("HH:mm")) + "～", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "hospital-visit-detail-1-edit",
                                  onClick: ($event: any) => (
                        handleHospitalVisitModalOpen(
                          hospitalVisit.hospitalVisitId
                        )
                      )
                                }, [
                                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_edit_exercise_routine.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("hospitalVisit_card_button_edit")), 1)
                                ], 8, _hoisted_18)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("p", _hoisted_21, _toDisplayString(hospitalVisit?.hospitalName ||
                        _ctx.$t("hospitalVisit_card_text_no_hospital")), 1),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(hospitalVisit.visitPurpose), 1)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                (hospitalVisit?.hospitalDepartmentName)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(hospitalVisit.hospitalDepartmentName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_25, [
                                  _cache[7] || (_cache[7] = _createElementVNode("img", {
                                    src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(userDiseases.value?.find(
                          (disease) => hospitalVisit?.diseaseCode === disease.id
                        )?.name ?? _ctx.$t("hospitalVisit_select_option_no_diseases")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("hospitalVisit_card_label_prepare")), 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "hospital-visit-appendix-prepare-link",
                                    onClick: ($event: any) => (goToClinicNote(hospitalVisit.hospitalVisitId))
                                  }, [
                                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                                      src: "/server/necs/images/icon_link_hospital_visits.svg",
                                      alt: ""
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospitalVisit_card_button_add_notes")), 1)
                                  ], 8, _hoisted_30)
                                ]),
                                _createElementVNode("p", _hoisted_31, [
                                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_update_time.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(hospitalVisit.modifiedDate).format("YYYY年M月D日")), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        (!showAllFutureVisits.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (futureVisitsCount.value > MAX_HOSPITAL_VISIT_DISPLAY_COUNT)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("button", {
                                      class: "hospital-visit-add-button",
                                      onClick: toggleDisplayAll
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospitalVisit_card_label_view_more_1")) + _toDisplayString(futureVisitsCount.value - MAX_HOSPITAL_VISIT_DISPLAY_COUNT) + _toDisplayString(_ctx.$t("hospitalVisit_card_label_view_more_2")), 1),
                                      _cache[10] || (_cache[10] = _createElementVNode("img", {
                                        src: "/server/necs/images/arrow-right_icon.png",
                                        alt: ""
                                      }, null, -1))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                (hasPastVisits.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", {
                        class: "hospital-visit-switch",
                        ref_key: "pastVisitElement",
                        ref: pastVisitElement
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("hospitalVisit_heading_title_past_visit")), 1)
                          ])
                        ])
                      ], 512),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _cache[11] || (_cache[11] = _createElementVNode("img", {
                              src: "/server/necs/images/icon_filter.svg",
                              alt: ""
                            }, null, -1)),
                            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("hospitalVisit_card_label_filter")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _withDirectives(_createElementVNode("select", {
                                class: "hospital-visits-select-year",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedYear).value = $event)),
                                onChange: filterVisits
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(years), (year, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: year,
                                    key: year,
                                    selected: index === 0
                                  }, _toDisplayString(year), 9, _hoisted_42))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, selectedYear.value]
                              ]),
                              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("hospitalVisit_card_label_year")), 1)
                            ]),
                            _withDirectives(_createElementVNode("select", {
                              class: "hospital-visits-select-disease",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDisease).value = $event)),
                              onChange: filterVisits
                            }, [
                              _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("hospitalVisit_select_option_all_diseases")), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userDiseases.value, (disease) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: disease.id,
                                  key: disease.id
                                }, _toDisplayString(disease.name), 9, _hoisted_45))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, selectedDisease.value]
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastHospitalVisits.value, (hospitalVisit) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "hospital-visit-item",
                            key: hospitalVisit.hospitalVisitId
                          }, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("p", _hoisted_48, [
                                  (hospitalVisit?.visitDate)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_unref(dayjs)(hospitalVisit.visitDate).format("M月D日(dd)")), 1))
                                    : _createCommentVNode("", true),
                                  (hospitalVisit?.visitTime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_unref(dayjs)(hospitalVisit.visitTime).format("HH:mm")) + "～", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("button", {
                                  class: "hospital-visit-detail-1-edit",
                                  onClick: ($event: any) => (
                        handleHospitalVisitModalOpen(
                          hospitalVisit.hospitalVisitId
                        )
                      )
                                }, [
                                  _cache[12] || (_cache[12] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_edit_exercise_routine.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("hospitalVisit_card_button_edit")), 1)
                                ], 8, _hoisted_51)
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("p", _hoisted_54, _toDisplayString(hospitalVisit?.hospitalName ||
                        _ctx.$t("hospitalVisit_card_text_no_hospital")), 1),
                                _createElementVNode("p", _hoisted_55, _toDisplayString(hospitalVisit.visitPurpose), 1)
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                (hospitalVisit?.hospitalDepartmentName)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(hospitalVisit.hospitalDepartmentName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_58, [
                                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                                    src: "/server/necs/images/stethoscope_24dp_5F6368_FILL1_wght400_GRAD0_opsz24.png",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(userDiseases.value?.find(
                          (disease) => hospitalVisit?.diseaseCode === disease.id
                        )?.name ?? _ctx.$t("hospitalVisit_select_option_no_diseases")), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "hospital-visit-appendix-prepare-link",
                                    onClick: ($event: any) => (goToClinicNote(hospitalVisit.hospitalVisitId))
                                  }, [
                                    _cache[14] || (_cache[14] = _createElementVNode("img", {
                                      src: "/server/necs/images/icon_link_hospital_visits.svg",
                                      alt: ""
                                    }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("hospitalVisit_card_button_view_notes")), 1)
                                  ], 8, _hoisted_62)
                                ]),
                                _createElementVNode("p", _hoisted_63, [
                                  _cache[15] || (_cache[15] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_update_time.svg",
                                    alt: ""
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(hospitalVisit.modifiedDate).format("YYYY年M月D日")), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createVNode(Pagination, _mergeProps(paginationProps, {
                          onNotify: notify,
                          style: {"display":"flex","justify-content":"center","margin":"32px 0 12px"}
                        }), null, 16)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode(Footer, {
          "scroll-target": componentId,
          "active-menu": activeMenu
        })
      ])
    ]),
    (errorDialog.show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, errorDialog, {
          onOk: errorDialog.close,
          onCancel: errorDialog.close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (showHospitalVisitAddEditModal.value)
      ? (_openBlock(), _createBlock(HospitalVisitEdit, {
          key: 1,
          "hospital-visit-id": selectedHospitalVisitId.value,
          onClose: handleHospitalVisitModalClose,
          onFetchHospitalVisits: refreshHospitalVisits
        }, null, 8, ["hospital-visit-id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})